import { Component, Fragment } from 'react';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { verifyUKCrownPostcode, verifyUKPostcode } from '../../helpers/address';
import { FormFieldError } from '../FormFieldError/FormFieldError';
import { SelectWithSearch } from '../selectWithSearch';
import styles from './AutoAddress.module.css';
import messages from './AutoAddress.messages';
import { buildAddressLabel } from './AutoAddressHelper';

// eslint-disable-next-line import/no-default-export
export default class AutoAddress extends Component {
    constructor(props) {
        super(props);
        this.state = {
            postcode: null,
            address: '',
            searchable: true,
            addressSelected: false,
            isPostcodeValid: false
        };
    }

    searchAddress = (value) => {
        value = value.replace(/\s/g, '');
        this.props.onChange(value);
    };

    handleOnChange = (searchTerm) => {
        this.setState({
            isPostcodeValid: verifyUKPostcode(searchTerm)
        });
        this.searchAddressOnCorrectPostcode(searchTerm);
    };

    searchAddressOnCorrectPostcode = (searchTerm) => {
        const postcodeIsValidAndNotCrownDependency =
            verifyUKPostcode(searchTerm) && !verifyUKCrownPostcode(searchTerm);
        if (postcodeIsValidAndNotCrownDependency) {
            this.searchAddress(searchTerm);
        }
    };

    onSelect = (item) => {
        const { onChange, fetchedAddresses, input } = this.props;
        let address;

        if (item) {
            address = _.find(fetchedAddresses, {
                equifax_token: item.value
            });

            if (input) {
                input.onChange(address);
            }
        }

        onChange(address);
    };

    getAddresses = () => {
        const { fetchedAddresses } = this.props;

        if (fetchedAddresses.length === 0) {
            return [];
        }

        if (
            _.isPlainObject(fetchedAddresses) ||
            Object.keys(fetchedAddresses[0]).length === 1
        ) {
            return [];
        }

        return _.map(fetchedAddresses, (address) => {
            return {
                label: `${buildAddressLabel(address)}`,
                value: address.equifax_token
            };
        });
    };

    renderInvalidPostcodeMessage = () => {
        return (
            <div className="no-results-custom">
                <span className="head">
                    <FormattedMessage {...messages.invalidPostcode} />
                </span>
                <span className="body">
                    <FormattedMessage {...messages.invalidPostcodeReason} />
                </span>
            </div>
        );
    };

    returnPostcodeErrorMessage = () => {
        return this.renderInvalidPostcodeMessage();
    };

    renderNoResults = () => {
        return this.returnPostcodeErrorMessage();
    };

    getSelectedLabel = () => {
        const { input } = this.props;

        if (_.get(input, 'value.ptc_abs_code')) {
            return buildAddressLabel(input.value);
        }
    };

    renderNoSearchTerm = () => {
        return (
            <div className={styles.NoSearchTerm}>
                <div className={styles.title}>
                    <FormattedMessage {...messages.enterPostcode} />
                </div>
                <div className={styles.description}>
                    <FormattedMessage {...messages.enterPostcodeReason} />
                </div>
            </div>
        );
    };

    shouldDisplayMenuMessageOnBlur() {
        return !this.state.isPostcodeValid;
    }

    showAutoAddressError() {
        const { meta } = this.props;

        if (meta) {
            return (
                meta.touched &&
                meta.error &&
                !!(Object.keys(meta.error).length !== 1)
            );
        }
    }

    render() {
        const { fetchedAddresses, input, addressIndex, onManualAddressToggle } =
            this.props;
        const value = input && input.value ? input.value.equifax_token : null;
        const errorMessage = messages.enterAddress;
        const showAutoAddressError = this.showAutoAddressError();
        return (
            <>
                {showAutoAddressError && (
                    <FormFieldError
                        className={styles.autoAddressError}
                        message={errorMessage}
                    />
                )}
                <SelectWithSearch
                    data-testid="address-lookup"
                    className={classNames(styles.AddressLookup, 'fs-exclude')}
                    focusedClassName={classNames(styles.AddressLookupFocused)}
                    hasMoreThanFourResults={this.getAddresses().length > 4}
                    items={this.getAddresses()}
                    value={value}
                    onChange={this.handleOnChange}
                    onButtonClick={this.searchAddress}
                    onBlur={this.searchAddress}
                    selectedLabel={this.getSelectedLabel()}
                    onSelect={this.onSelect}
                    isLoading={fetchedAddresses.fetching}
                    isSuccess={fetchedAddresses.success}
                    helperText={
                        <FormattedMessage {...messages.chooseAddress} />
                    }
                    switchPosition={'top'}
                    manualSwitchText={
                        <FormattedMessage {...messages.enterManually} />
                    }
                    placeholder="Search for your postcode"
                    noResultsRenderer={this.renderNoResults}
                    noSearchTermRenderer={this.renderNoSearchTerm}
                    shouldDisplayMenuMessageOnBlur={this.shouldDisplayMenuMessageOnBlur()}
                    manualSwitch={() => onManualAddressToggle(addressIndex)}
                />
                <div
                    className={styles.manualAddressToggle}
                    onClick={() => onManualAddressToggle(addressIndex)}
                >
                    <FormattedMessage {...messages.enterAddressManually} />
                </div>
            </>
        );
    }
}
